<style lang="less" scoped>
.popular {
  color: rgb(25, 26, 27);
  margin-top: 15px;
  .title {
    height: 24px;
    display: block;
    font-size: 17px;
    font-weight: 600;
  }
  .no-page-line{
    color: #EDEDED;
    background: #EDEDED;
    height: 1px;
    width: 100%;
    display: block;
  }
  .popular-list {
    list-style-type: none;
    margin: 0px;
    justify-content: space-between;
    display: flex;
    flex-wrap: wrap;
    .popular-item-hidden {
      visibility: hidden;
    }
  }
  .page-infinite-loading {
    text-align: center;
    height: 50px;
    line-height: 50px;
    span {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .page-loading-visible {
    visibility: hidden;
  }
  .no-more {
    text-align: center;
    color: rgb(189, 192, 197);
    padding: 15px 0;
  }
}
</style>

<template>
  <div class="popular border-radius-8" v-if="goodsList.length>0" >
    <div class="title" v-if="!isnopage">猜你喜欢</div>
    <div class="title" v-else>为您推荐</div>
    <i class="no-page-line" v-if="isnopage"></i>
    <div
      class="popular-list"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="50"
    >
      <goods-list
        :goodsList="popular"
        :viewTrackData="viewDataTrack"
        @click-goods-item="clickGoodsItem"
      ></goods-list>
    </div>
    <slot v-if="isShowNoMore"></slot>
    <div v-if="isShowNoMore" class="no-more">- 我是有底线的 -</div>
    <p
      v-show="!isShowNoMore"
      class="page-infinite-loading"
      :class="{'page-loading-visible': !loading}"
    >
      <mt-spinner type="fading-circle"></mt-spinner>加载中...
    </p>
  </div>
</template>

<script>
import { goodsListFormat } from "../../../util/function";
import lazyImg from "../../../components/lazy-img";
import icon from "../../../components/icon";
import price from "../../../components/price";
import { InfiniteScroll, Spinner } from "mint-ui";
import goodsList from "../../../components/goods-list";
import { trackData } from "../../../directives/track.js";
import _ from "underscore";
import keepAlive from '../../../mixins/common/keep-alive.js'
const DefaultPageSize = 10;
const DefaultPageNum = 1;

export default {
  props: ["isnopage"],
  name: "popular",
  mixins: [keepAlive],
  data() {
    return {
      currentPageNum: DefaultPageNum,
      total: 0,
      goodsList: [],
      loading: false,
      viewDataTrack: {
        trackId: 2001,
        algorithmId: null,
        // data: []
      },
      getProductError: false //是否正确获取商品
    };
  },
  directives: {
    InfiniteScroll
  },
  computed: {
    popular() {
      const list = goodsListFormat(this.goodsList)

      // list数量为奇数时，填充一个item 为了布局好看
      // if (list.length % 2 === 1) {
      //   list.push({
      //     id: -99,
      //     href: "",
      //     masterName: "",
      //     slaveName: "",
      //     price: "",
      //     marketPrice: "",
      //     imgUrl: ""
      //   });
      // }
      return list;
    },
    isShowNoMore() {
      return (
        this.currentPageNum * DefaultPageSize >= this.total &&
        !this.loading &&
        !this.getProductError
      );
    },
  },
  methods: {
    loadMore() {
      if (this.isShowNoMore || this.loading || !this.isInActive) {
        return;
      }

      const data = {
        type: 1, // 1 表示首页推荐品类
        wd: "",
        pageSize: DefaultPageSize,
        pageNum: this.currentPageNum + 1
      };
      this.loading = true;
      this.getProductError = false;
      this.$store
        .dispatch("getRecommendGoods", data)
        .then(data => {
          this.loading = false;
          this.goodsList = this.goodsList.concat(data.list);
          this.total = data.page.total;
          this.currentPageNum = data.page.pageNum;
          this.viewDataTrack.algorithmId = data.algorithmId
          this.getProductError = false;
        })
        .catch(e => {
          this.loading = false;
          this.getProductError = true;
        });
    },
    clickGoodsItem(i) {
      const indexStart = i - 5 < 0 ? 0 : i - 5;
      const indexEnd =
        i + 5 > this.popular.length ? this.popular.length : i + 5;
      const paramList = this.popular.slice(indexStart, indexEnd);
      const skuIdList = _.filter(
        paramList.map(item => {
          return item.skuId;
        }),
        skuId => {
          return this.popular[i].skuId !== skuId;
        }
      );
      console.log(this.goodsList,'-this.goodsList-');
      trackData({
        id: 3001,
        data: {
          aId: this.viewDataTrack.algorithmId + '',
          pId: this.goodsList[i].productId + ''
        }
      })

      // trackData({
      //   id: 344,
      //   p: [this.viewDataTrack.algorithmId, this.popular[i].skuId, ...skuIdList]
      // });
    }
  },
  mounted() {
    const data = {
      type: 1, // 1 表示首页推荐品类
      wd: "",
      pageSize: DefaultPageSize,
      pageNum: DefaultPageNum
    };

    setTimeout(() => {
       this.$store
      .dispatch("getRecommendGoods", data)
      .then(data => {
        this.loading = false;
        this.goodsList = data.list;
        this.total = data.page.total;
        this.currentPageNum = data.page.pageNum;
        this.viewDataTrack.algorithmId = data.algorithmId
        // this.viewDataTrack.data[0] = data.algorithmId;
      })
      .catch(e => {
        this.loading = false;
        console.log(e);
      });
    }, 0);
    this.loading = true;
  },
  components: {
    "lazy-img": lazyImg,
    icon,
    price,
    goodsList,
    [Spinner.name]: Spinner
  }
};
</script>


